export function SET_DONT_SHOW_AGAIN(state, dontShowAgain) {
  state.dontShowAgain = dontShowAgain;
}

export function INCREMENT_VIEW_COUNT(state) {
  state.viewCount += 1;
}
